import 'css-chunk:src/feature/check/CheckActivityRow.module.scss';export default {
  "root": "CheckActivityRow_root",
  "inner-grid": "CheckActivityRow_inner-grid",
  "grid-item-fill": "CheckActivityRow_grid-item-fill",
  "outer-grid": "CheckActivityRow_outer-grid",
  "grid": "CheckActivityRow_grid",
  "modifier-name": "CheckActivityRow_modifier-name"
};